import React from "react";

const LandingPage = () => {
  return (
    <div className="px-16 py-10">
      <div className="flex flex-col justify-center items-center mt-28 bg-gray-100 rounded-lg drop-shadow-2xl py-10 mb-20">
        <h1 className="text-center font-semibold text-6xl">Welcome To <br /><span className="text-[#EC1D23]">Glock Auto Parts</span></h1>
        <p className="text-center w-[80%] text-gray-500 mt-4">Your one-stop shop for managing sales orders, importing lists, tracking inventory and more all in one place!</p>
      </div>
    </div>
  );
};

export default LandingPage;
